<template>
    <div class="booking-view myskov-orders">
        <img height="1" width="1" style="border-style:none;" alt="" :src="googleAdService" />
        <div class="booking-view__body">
            <msg-block type="success">
                <p><b>{{ translations.msg_thank_you_title }} {{ tourOperatorName }}</b></p>
                <p v-html="translations.msg_thank_you_txt"></p>
            </msg-block>
            <order v-if="order" :order="order" class="myskov-order-block--print"></order>
            <div class="link-block link-block--trustpilot">
                <div class="link-block__img">
                    <img img src="./../../img/logos/trustpilot-logo.svg" alt="">
                </div>
                <div class="link-block__text">
                    <p><b v-text="translations.trustpilot_title"></b></p>
                    <p v-html="translations.trustpilot_txt"></p>
                </div>
            </div>
            </div>
        </div>
</template>

<script>
import MsgBlock from './../components/msg-block.vue'
import Order from './../components/order.vue';
import _ from 'underscore';
import { trackEvent } from "../tracker";

export default {
    data() {
        return {
            translations: APP_CONFIG.TRANSLATION.ORDER_PAGE,
            bookingFormData: {}            
        }
    },
    mounted() {
        if(!this.order) {
            window.location = '/';
        } else {
            this.bookingFormData = Object.assign({}, this.$store.state.savedBookingFormData);
            this.$store.commit('savedBookingFormData', { });
            this.doTracking();
        }
    },
    components: {
        MsgBlock,
        Order
    },
    computed: {
        order() {
            return (!_.isEmpty(this.$store.state.bookedOffer)) ? this.$store.state.bookedOffer : null;
        },
        packageOffer() {
            if(this.order && this.order.packageOffer) {
                return this.order.packageOffer;
            }

            return null;
        },
        tourOperatorName() {
            if(this.packageOffer && this.packageOffer.tourOperator) {
                return this.packageOffer.tourOperator.name;
            }

            return '';
        },
        transactionId() {
            return (this.order) ? this.$route.params.draftid : null
        },
        convValue() {
            let convVal = (this.order) ? _.propertyOf(this.order)(['packageOffer', 'totalPrice', 'value']) : 0;
            if(convVal) {
                return convVal * 0.0669;
            }

            return 0;
        },
        googleAdService() {
            return '//www.googleadservices.com/pagead/conversion/1002018338/?value=' + this.convValue.toFixed(2) + '&label=-M51CJaHwwgQoqzm3QM&guid=ON&script=0';
        }
    },
    methods: {
        doTracking() {
            if(this.transactionId && this.convValue > 0) {
                this.gaTracking();
                this.fbTracking();
                this.scripts();
                this.gtag();
            }
        },
        gaTracking() {
            this.$ga.ecommerce.addTransaction({
                id: this.transactionId, // Transaction ID. Required.
                affiliation: 'Skov Rejser',   // Affiliation or store name.
                revenue: this.convValue.toFixed(2), // Grand Total.
                shipping: '0', // Shipping.
                tax: '0' // Tax.
            })

            this.$ga.ecommerce.send()
        },
        fbTracking() {
            if(window.fbq) {
                window.fbq('track', 'Purchase', {
                    currency: 'DKK',
                    value: this.convValue.toFixed(2),
                });
            }
        },
        gtag() {
            trackEvent({
                event:'OrderComplete',
                orderTotal: this.convValue,
                orderId: this.transactionId,
                firstName: (this.bookingFormData.customer) ? this.bookingFormData.customer.firstName : '',
                lastName: (this.bookingFormData.customer) ? this.bookingFormData.customer.lastName : '',
                email: (this.bookingFormData.customer) ? this.bookingFormData.customer.email : ''
            });
        },
        scripts() {
            this.addScript('/adserviceRoute.php?sid=2&cid=4959&order_id=' + this.transactionId);
            //this.addScript('https://online.adservicemedia.dk/cgi-bin/API/ConversionService/js?camp_id=4959&order_id=' + this.transactionId);
        },
        addScript(script) {
            let js = document.createElement('script');
            js.src = script;
            document.getElementsByTagName('head')[0].appendChild(js);
        }
    }
}
</script>
